export const CREATE_RMA = 'CREATE_RMA';
export const CREATE_RMA_FULFILLED = 'CREATE_RMA_FULFILLED';
export const CREATE_RMA_REJECTED = 'CREATE_RMA_REJECTED';
export const FETCH_RMA = 'FETCH_RMA';
export const FETCH_RMA_FULFILLED = 'FETCH_RMA_FULFILLED';
export const FETCH_RMA_REJECTED = 'FETCH_RMA_REJECTED';
export const FETCH_RMA_INVOICE = 'FETCH_RMA_INVOICE';
export const FETCH_RMA_INVOICE_FULFILLED = 'FETCH_RMA_INVOICE_FULFILLED';
export const FETCH_RMA_INVOICE_REJECTED = 'FETCH_RMA_INVOICE_REJECTED';
export const UPDATE_RMA = 'UPDATE_RMA';
export const UPDATE_RMA_FULFILLED = 'UPDATE_RMA_FULFILLED';
export const UPDATE_RMA_REJECTED = 'UPDATE_RMA_REJECTED';
export const CANCEL_RMA = 'CANCEL_RMA';
export const CANCEL_RMA_FULFILLED = 'CANCEL_RMA_FULFILLED';
export const CANCEL_RMA_REJECTED = 'CANCEL_RMA_REJECTED';
export const SEND_RMA_EMAIL = 'SEND_RMA_EMAIL';
export const SEND_RMA_EMAIL_FULFILLED = 'SEND_RMA_EMAIL_FULFILLED';
export const SEND_RMA_EMAIL_REJECTED = 'SEND_RMA_EMAIL_REJECTED';
export const CLEAR_ACCOUNT_RMA = 'CLEAR_ACCOUNT_RMA';
export const CLEAR_RMA_CANCEL = 'CLEAR_RMA_CANCEL';
export const CLEAR_RMA_CREATE = 'CLEAR_RMA_CREATE';
export const CLEAR_RMA_INVOICES = 'CLEAR_RMA_INVOICES';
export const CLEAR_RMA_UPDATE = 'CLEAR_RMA_UPDATE';
export const CLEAR_RMA_SEND_EMAIL = 'CLEAR_RMA_SEND_EMAIL';
